import type { CapacityLimit } from '@morpho-org/blue-sdk'

import { isDefined } from '@morpho-org/morpho-ts'

// While MAX is active the input mirrors the live max, so a max that recomputes in the same
// render (e.g. the WETH/ETH wrap toggle) never leaves the amount a commit behind.
export const resolveStickyMaxAmount = (
  isMax: boolean,
  max: CapacityLimit | undefined,
  rawInputAmount: bigint
): bigint => (isMax && isDefined(max) ? max.value : rawInputAmount)

export const computeVaultDepositFunding = ({
  inputAmount,
  isWrapping
}: {
  inputAmount: bigint
  isWrapping: boolean
}): { erc20Amount: bigint; nativeAmount: bigint } =>
  isWrapping
    ? { erc20Amount: 0n, nativeAmount: inputAmount }
    : { erc20Amount: inputAmount, nativeAmount: 0n }

// Whether the input sits on the spendable-balance edge that can't be trusted while the gas
// reserve is unreadable: an explicit MAX, or an amount equal to the full balance, on a
// gas-token vault.
export const isAtUnpricedGasTokenLimit = ({
  isGasToken,
  isReserveError,
  userBalance,
  inputAmount,
  isMax
}: {
  isGasToken: boolean
  isReserveError: boolean
  userBalance: bigint | undefined
  inputAmount: bigint
  isMax: boolean
}): boolean =>
  isGasToken &&
  isReserveError &&
  isDefined(userBalance) &&
  inputAmount > 0n &&
  (isMax || inputAmount === userBalance)

export const getVaultDepositBalance = ({
  isWrapping,
  userBalance,
  wrappableNativeBalance
}: {
  isWrapping: boolean
  userBalance: bigint | undefined
  wrappableNativeBalance: bigint
}) => (isWrapping ? wrappableNativeBalance : userBalance)
